/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface FavoriteFontAdd$Params {
  menuId: string;
  fontName: string;
}

export function favoriteFontAdd(http: HttpClient, rootUrl: string, params: FavoriteFontAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, favoriteFontAdd.PATH, 'post');
  if (params) {
    rb.path('menuId', params.menuId, {});
    rb.path('fontName', params.fontName, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

favoriteFontAdd.PATH = '/api/FavoriteFont/{menuId}/add/{fontName}';
